import React from 'react';
import { CardProps, StatCardProps } from '@/types/components';

export const Card: React.FC<CardProps> = ({
  children,
  title,
  className = '',
}) => {
  return (
    <div
      className={`bg-bg-white-0 shadow-xs rounded-lg border border-stroke-soft-200 overflow-hidden ${className}`}
    >
      {title && (
        <div className="px-6 py-4 border-b border-stroke-soft-200">
          <h3 className="text-lg font-semibold text-text-strong-950">{title}</h3>
        </div>
      )}
      <div className="p-6">{children}</div>
    </div>
  );
};

export const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon,
  color = 'blue',
  className = '',
}) => {
  const colorClasses = {
    blue: 'bg-information-lighter text-information-base border-information-light',
    green: 'bg-success-lighter text-success-base border-success-light',
    yellow: 'bg-away-lighter text-away-base border-away-light',
    red: 'bg-error-lighter text-error-base border-error-light',
    purple: 'bg-feature-lighter text-primary border-feature-light',
  };

  return (
    <div
      className={`bg-bg-white-0 shadow-xs rounded-lg border ${colorClasses[color]} ${className}`}
    >
      <div className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-text-sub-600">{title}</p>
            <p className="text-3xl font-bold text-text-strong-950 mt-1">{value}</p>
          </div>
          {icon && (
            <div className={`p-3 rounded-full ${colorClasses[color]}`}>
              {icon}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
